import { AdministracionCarguePickingModule } from './modules/administracion-cargue-picking/administracion-cargue-picking.module';

import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";
import { ModificausuarioComponent } from "./components/modificausuario/modificausuario.component";
import { AsignacionServiciosComponent } from "./components/asignacion-servicios/asignacion-servicios.component";
import { ServiciosasignadosComponent } from "./components/serviciosasignados/serviciosasignados.component";
import { AdministracionConductoresComponent } from "./components/administracion-conductores/administracion-conductores.component";
import { AdministracionCausalesNoEntregaComponent } from "./components/administracion-causales-no-entrega/administracion-causales-no-entrega.component";
import { AdministracionMotivoDevolucionComponent } from "./components/administracion-motivo-devolucion/administracion-motivo-devolucion.component";
import { AdministracionEmpresaTransporteComponent } from "./components/administracion-empresa-transporte/administracion-empresa-transporte.component";
import { AdministracionUsuarioWebComponent } from "./components/administracion-usuario-web/administracion-usuario-web.component";
import { AdministracionMensajesComponent } from "./components/administracion-mensajes/administracion-mensajes.component";

import { AdministracionTiposNovedadesComponent } from "./components/administracion-tipos-novedades/administracion-tipos-novedades.component";
import { AdministracionMotivosComponent } from "./components/administracion-motivos/administracion-motivos.component";

import { AdministracionClientesNuevosComponent } from "./components/administracion-clientes-nuevos/administracion-clientes-nuevos.component";

import { AsignacionTransportadorAgenciaComponent } from "./components/asignacion-transportador-agencia/asignacion-transportador-agencia.component";
import { AsignacionTransportadorVehiculoComponent } from "./components/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component";

import { InformeProductosComponent } from "./components/informe-productos/informe-productos.component";
import { InformeClientesComponent } from "./components/informe-clientes/informe-clientes.component";
import { InformeHabeasDataComponent } from "./components/informe-habeas-data/informe-habeas-data.component";

import { InformeVentasProductoComponent } from "./components/informe-ventas-producto/informe-ventas-producto.component";
import { InformeUnidadesClienteComponent } from "./components/informe-unidades-cliente/informe-unidades-cliente.component";

import { InformeInicioGestionComponent } from "./components/informe-inicio-gestion/informe-inicio-gestion.component";
import { InformeOrdenesPedidoComponent } from "./components/informe-ordenes-pedido/informe-ordenes-pedido.component";

import { EntregasCompletasComponent } from "./components/entregas-completas/entregas-completas.component";
import { EntregasParcialesComponent } from "./components/entregas-parciales/entregas-parciales.component";
import { EntregasComponent } from "./components/entregas/entregas.component";
import { TiemposRutasComponent } from "./components/tiempos-rutas/tiempos-rutas.component";
import { RutaEntregasComponent } from "./components/ruta-entregas/ruta-entregas.component";
import { UbicacionComponent } from "./components/ubicacion/ubicacion.component";
import { InformeRecorridoVendedorComponent } from "src/app/components/informe-recorrido-vendedor/informe-recorrido-vendedor.component";
import { AdministracionMenuWebComponent } from "./components/administracion-menu-web/administracion-menu-web.component";



const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    data: { title: "login" },
  },
  /*{
    path: "login",
    loadChildren: () =>
      import("./modules/login/login.module").then((m) => m.LoginModule),
    data: { title: "Login" },
  },*/
  {
    path: "inicio",
    loadChildren: () =>
      import("./modules/inicio/inicio.module").then((m) => m.InicioModule),
    data: { title: "Inicio" },
  },
  {
    path: "creacionusuarios",
    loadChildren: () =>
      import("./modules/usuarios/usuarios.module").then(
        (m) => m.UsuariosModule
      ),
    data: { title: "Gestión Usuarios" },
  },
  {
    path: "modificausuario",
    component: ModificausuarioComponent,
    data: { title: "Nuevo" },
  },
  {
    path: "gestionmaestras",
    loadChildren: () =>
      import("./modules/gestion-maestras/gestion-maestras.module").then(
        (m) => m.GestionMaestrasModule
      ),
    data: { title: "Gestión Maestras" },
  },
  {
    path: "asignacionservicios",
    component: AsignacionServiciosComponent,
    data: { title: "Nuevo" },
  },
  {
    path: "serviciosasignados",
    component: ServiciosasignadosComponent,
    data: { title: "Servicios Asignados" },
  },
  {
    path: "administracionconductores",
    component: AdministracionConductoresComponent,
    data: { title: "Administracion Conductores" },
  },
  {
    path: "administracioncausalesnoentrega",
    component: AdministracionCausalesNoEntregaComponent,
    data: { title: "Administracion Causales No Entrega" },
  },
  {
    path: "administracionmotivodevolucion",
    component: AdministracionMotivoDevolucionComponent,
    data: { title: "Administracion Motivos Devolucion" },
  },
  {
    path: "administracionempresatransporte",
    component: AdministracionEmpresaTransporteComponent,
    data: { title: "Administracion Empresas Transporte" },
  },
  {
    path: "administracionusuariosweb",
    component: AdministracionUsuarioWebComponent,
    data: { title: "Administracion Usuarios Web" },
  },
  {
    path: "administracionmensajes",
    component: AdministracionMensajesComponent,
    data: { title: "Administracion Mensajes" },
  },
  {
    path: "administraciontarifas",
    loadChildren: () =>
      import("./modules/precios/precios.module").then((m) => m.PreciosModule),
    data: { title: "Gestión Maestras" },
  },
  {
    path: "administracionproductos",
    loadChildren: () =>
      import("./modules/productos/productos.module").then(
        (m) => m.ProductosModule
      ),
    data: { title: "Administración Productos" },
  },
  {
    path: "picking",
    loadChildren: () =>
      import("./modules/picking/picking.module").then((m) => m.PickingModule),
    data: { title: "Administracion Picking" },
  },
  {
    path: "generacionarchivos",
    loadChildren: () =>
      import("./modules/generacion-archivos/generacion-archivos.module").then(
        (m) => m.GeneracionArchivosModule
      ),
    data: { title: "Generación Archivos" },
  },
  {
    path: "administracionagencia",
    loadChildren: () =>
      import("./modules/agencia/agencia.module").then((m) => m.AgenciaModule),
    data: { title: "Administracion Mensajes" },
  },
  {
    path: "asignaciontransportadoragencia",
    component: AsignacionTransportadorAgenciaComponent,
    data: { title: "Administracion Mensajes" },
  },
  {
    path: "asignaciontransportadorvehiculo",
    component: AsignacionTransportadorVehiculoComponent,
    data: { title: "Administracion Mensajes" },
  },
  {
    path: "administraciontiposnovedades",
    component: AdministracionTiposNovedadesComponent,
    data: { title: "Administracion Tipos Novedades" },
  },
  {
    path: "administracionmotivos",
    component: AdministracionMotivosComponent,
    data: { title: "Administracion Motivos" },
  },
  {
    path: "administracionrutero",
    loadChildren: () =>
      import("./modules/rutero/rutero.module").then((m) => m.RuteroModule),
    data: { title: "Administracion Rutero" },
  },
  {
    path: "administracionjerarquia",
    loadChildren: () =>
      import("./modules/jerarquias/jerarquias.module").then(
        (m) => m.JerarquiasModule
      ),
    data: { title: "Administracion Jerarquías" },
  },
  {
    path: "autorizacionpedidos",
    loadChildren: () =>
      import("./modules/autorizacion-pedidos/autorizacion-pedidos.module").then(
        (m) => m.AutorizacionPedidosModule
      ),
    data: { title: "Autorización Pedidos" },
  },
  {
    path: "pedidoweb",
    loadChildren: () =>
      import("./modules/pedido-web/pedido-web.module").then(
        (m) => m.PedidoWebModule
      ),
    data: { title: "Pedido Web" },
  },
  {
    path: "administracionclientesnuevos",
    component: AdministracionClientesNuevosComponent,
    data: { title: "Administracion Clientes Nuevos" },
  },
  {
    path: "entregascompletas",
    component: EntregasCompletasComponent,
    data: { title: "Entregas Completas" },
  },
  {
    path: "entregasparciales",
    component: EntregasParcialesComponent,
    data: { title: "Entregas Parciales" },
  },
  {
    path: "entregas",
    component: EntregasComponent,
    data: { title: "Entregas" },
  },
  {
    path: "informeproductos",
    component: InformeProductosComponent,
    data: { title: "Informe Productos" },
  },
  {
    path: "informeclientes",
    component: InformeClientesComponent,
    data: { title: "Informe Clientes" },
  },
  {
    path: "informehabeasdata",
    component: InformeHabeasDataComponent,
    data: { title: "Informe Habeas Data" },
  },
  {
    path: "informegestionvendedor",
    loadChildren: () =>
      import(
        "./modules/informe-gestion-vendedor/informe-gestion-vendedor.module"
      ).then((m) => m.InformeGestionVendedorModule),
    data: { title: "Informe Gestion Vendedor" },
  },
  {
    path: "informegestionvendedorcartera",
    loadChildren: () =>
      import(
        "./modules/informe-gestion-vendedor-cartera/informe-gestion-vendedor-cartera.module"
      ).then((m) => m.InformeGestionVendedorCarteraModule),
    data: { title: "Informe Gestion Vendedor Cartera" },
  },
  {
    path: "informegestionb2c",
    loadChildren: () =>
      import("./modules/informe-gestion-b2c/informe-gestion-b2c.module").then(
        (m) => m.InformeGestionB2cModule
      ),
    data: { title: "Informe Gestion B2C" },
  },
  {
    path: "informenovedadesvendedor",
    loadChildren: () =>
      import(
        "./modules/informe-novedades-vendedor/informe-novedades-vendedor.module"
      ).then((m) => m.InformeNovedadesVendedorModule),
    data: { title: "Informe Novedades Vendedor" },
  },
  {
    path: "informeventasdetalle",
    loadChildren: () =>
      import(
        "./modules/informe-ventas-detalle/informe-ventas-detalle.module"
      ).then((m) => m.InformeVentasDetalleModule),
    data: { title: "Informe Ventas Detalle" },
  },
  {
    path: "informeventasproducto",
    loadChildren: () =>
      import(
        "./modules/informe-ventas-producto/informe-ventas-producto.module"
      ).then((m) => m.InformeVentasProductoModule),
    data: { title: "Informe Ventas Producto" },
  },
  {
    path: "informeventascategoria",
    loadChildren: () =>
      import(
        "./modules/informe-ventas-grupo-marca-linea/informe-ventas-grupo-marca-linea.module"
      ).then((m) => m.InformeVentasGrupoMarcaLineaModule),
    data: { title: "Informe Ventas Categoria" },
  },
  {
    path: "informeproductos",
    loadChildren: () =>
      import("./modules/informe-productos/informe-productos.module").then(
        (m) => m.InformeProductosModule
      ),
    data: { title: "Informe Productos" },
  },
  {
    path: "informeclientesnuevos",
    loadChildren: () =>
      import(
        "./modules/informe-clientes-nuevos/informe-clientes-nuevos.module"
      ).then((m) => m.InformeClientesNuevosModule),
    data: { title: "Informe Clientes Nuevos" },
  },
  {
    path: "informeventaefectiva",
    loadChildren: () =>
      import(
        "./modules/informe-venta-efectiva/informe-venta-efectiva.module"
      ).then((m) => m.InformeVentaEfectivaModule),
    data: { title: "Informe Venta Efectiva" },
  },
  {
    path: "informeordenpedidos",
    component: InformeOrdenesPedidoComponent,
    data: { title: "Informe Orden Pedidos" },
  },
  {
    path: "informeventasproducto",
    component: InformeVentasProductoComponent,
    data: { title: "Informe Ventas Producto" },
  },
  {
    path: "informeunidadescliente",
    component: InformeUnidadesClienteComponent,
    data: { title: "Informe Unidades Cliente" },
  },
  {
    path: "informerecorridovendedor",
    component: InformeRecorridoVendedorComponent,
    data: { title: "Informe Recorrido Vendedor" },
  },
  /*{
    path: "informerecorridovendedor",
    loadChildren: () =>
      import(
        "./modules/informe-recorrido-vendedor/informe-recorrido-vendedor.module"
      ).then((m) => m.InformeRecorridoVendedorModule),
    data: { title: "Informe Recorrido Vendedor" },
  },*/
  {
    path: "informeiniciogestion",
    component: InformeInicioGestionComponent,
    data: { title: "Informe Inicio Gestion" },
  },

  {
    path: "tiemporutas",
    component: TiemposRutasComponent,
    data: { title: "Tiempo Rutas" },
  },
  {
    path: "rutaentregas",
    component: RutaEntregasComponent,
    data: { title: "Ruta Entregas" },
  },
  {
    path: "ubicacion",
    component: UbicacionComponent,
    data: { title: "Ubicacion" },
  },
  {
    path: "encuestasfijas",
    loadChildren: () =>
      import("./modules/encuestas-fijas/encuestas-fijas.module").then(
        (m) => m.EncuestasFijasModule
      ),
    data: { title: "Gestion Encuestas" },
  },
  {
    path: "administracionpresupuesto",
    loadChildren: () =>
      import(
        "./modules/administracion-presupuesto/administracion-presupuesto.module"
      ).then((m) => m.AdministracionPresupuestoModule),
    data: { title: "Administración de Presupuesto" },
  },
  {
    path: "administracioncorreo",
    loadChildren: () =>
      import(
        "./modules/administracion-correos/administracion-correos.module"
      ).then((m) => m.AdministracionCorreosModule),
    data: { title: "Administración Correos" },
  },

  {
    path: "reporteentregas",
    loadChildren: () =>
      import("./modules/reporte-entregas/reporte-entregas.module").then(
        (m) => m.ReporteEntregasModule
      ),
    data: { title: "Reporte Entregas" },
  },

  {
    path: "administradormenuweb",
    loadChildren: () =>
      import("./modules/administracion-menu-web/administracion-menu-web.module").then(
        (m) => m.AdministracionMenuWebModule
      ),
    data: { title: "Administración Menu Web" },
  },
  {
    path: "administradorentrtpovehiculo",
    loadChildren: () =>
      import(
        "./modules/administracion-entr-tpovehiculo/administracion-entr-tpovehiculo.module"
      ).then((m) => m.AdministracionEntrTpovehiculoModule),
    data: { title: "Administracion Tipos de Vehiculos" },
  },
  {
    path: "administradorpicking",
    loadChildren: () =>
      import(
        "./modules/administracion-cargue-picking/administracion-cargue-picking.module"
      ).then((m) => m.AdministracionCarguePickingModule),
    data: { title: "Administracion de Cargues" },
  },
  // {
  //   path: 'administradorpicking',
  //   component: AdministracionPickingComponent ,
  //   data: { title: 'Administracion de Cargues' },
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const routingComponents = [
  LoginComponent,
  ModificausuarioComponent,
  AsignacionServiciosComponent,
  AdministracionConductoresComponent,
  AdministracionCausalesNoEntregaComponent,
  AdministracionMotivoDevolucionComponent,
  AdministracionEmpresaTransporteComponent,
  AdministracionUsuarioWebComponent,
  AdministracionMensajesComponent,
  AdministracionClientesNuevosComponent,
  AsignacionTransportadorAgenciaComponent,
  AsignacionTransportadorVehiculoComponent,
  EntregasCompletasComponent,
  EntregasParcialesComponent,
  EntregasComponent,
  TiemposRutasComponent,
  RutaEntregasComponent,
  UbicacionComponent
];
